import { resolveFunnelName } from '../utils/saveRoutesCookie';

export function useFunnelName(queryFunnel?: unknown): string {
  const funnelId = useFunnelContext().value;
  const { public: { ENVIRONMENT }, app: { baseURL } } = useRuntimeConfig();
  const override = ENVIRONMENT === 'production' ? undefined : queryFunnel;

  return resolveFunnelName(funnelId, baseURL, override);
}
